import React from 'react';
import { t } from 'i18next';
import { ModalContainer } from 'src/components/Modals/components';
import MvpAppBody from 'src/components/Modals/components/MvpAppBody';

interface Props {
  title: string;
  footer?: JSX.Element;
  onConfirm?: () => void;
  onCancel?: () => void;
  message?: any;
}

const MvpAppSuccessMessage = ({
  onCancel,
  onConfirm,
  footer,
  title = t('YouHaveSuccessfullySignedTheAgreementInMvpAppHeader'),
  message = t('YouHaveSuccessfullySignedTheAgreementInMvpAppText'),
}: Props) => {
  return (
    <ModalContainer width={320}>
      <MvpAppBody
        onConfirm={onConfirm}
        onCancel={onCancel}
        title={title}
        footer={footer}
        contentMessage={message}
        isSuccessDialog={true}
      />
    </ModalContainer>
  );
};

export default MvpAppSuccessMessage;
